/**
 * Opens a Strava URL. On mobile devices tries the native app deep link first
 * (strava://...) and falls back to the web URL after 1.5 s if the app is not
 * installed. On desktop opens a new tab directly.
 *
 * Works for any strava.com path: activities, athletes, segments, etc.
 */
export function openStravaUrl(webUrl) {
  if (!webUrl) return;
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  if (!isMobile) {
    window.open(webUrl, "_blank", "noopener,noreferrer");
    return;
  }
  const appUrl = webUrl.replace("https://www.strava.com/", "strava://");
  window.location.href = appUrl;
  const timer = setTimeout(() => {
    if (!document.hidden) {
      window.open(webUrl, "_blank", "noopener,noreferrer");
    }
  }, 1500);
  document.addEventListener("visibilitychange", function cleanup() {
    if (document.hidden) clearTimeout(timer);
    document.removeEventListener("visibilitychange", cleanup);
  }, { once: true });
}
